import { Injectable } from '@angular/core';
import { PermissionsEnum } from '../models/role.model';
import { DashboardConfiguration } from '../models/utility.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { RoleService } from './role.service';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  // Permissions related to the user roles
  hasUtility: boolean = false;
  isMapViewAllowed: boolean = false;
  isCustomerViewAllowed: boolean = false;
  isCustomerCreateEditAllowed: boolean = false;
  isCustomerAssignAllowed: boolean = false;
  isCustomerRetagAllowed: boolean = false;
  isCustomerApproveRejectAllowed: boolean = false;
  isCustomerReviewAllowed: boolean = false;
  isCustomerAuditReviewAllowed: boolean = false;
  isCustomerRecallAssignedAllowed: boolean = false;
  isCustomerRecallValidatedAllowed: boolean = false;
  isCustomerUnvisitedAllowed: boolean = false;
  isCustomerNewEntryBreakdownAllowed: boolean = false;
  isCustomerDownloadAllowed: boolean = false;
  isTransformersCreateEditAllowed: boolean = false;
  isTransformersAssignAllowed: boolean = false;
  isTransformersRetagAllowed: boolean = false;
  isTransformersApproveRejectAllowed: boolean = false;
  isTransformersAuditReviewAllowed: boolean = false;
  isTransformersRecallAssignedAllowed: boolean = false;
  isTransformersRecallValidatedAllowed: boolean = false;
  isTransformersDownloadAllowed: boolean = false;
  isPoleCreateEditAllowed: boolean = false;
  isPoleDeleteAllowed: boolean = false;
  isPoleAssignAllowed: boolean = false;
  isPoleRetagAllowed: boolean = false;
  isPoleApproveRejectAllowed: boolean = false;
  isPoleAuditReviewAllowed: boolean = false;
  isPoleRecallAssignedAllowed: boolean = false;
  isPoleRecallValidatedAllowed: boolean = false;
  isPoleDownloadAllowed: boolean = false;
  isMVPoleViewAllowed: boolean = false;
  isMVPoleCreateEditAllowed: boolean = false;
  isMVPoleDeleteAllowed: boolean = false;
  isMVPoleAssignAllowed: boolean = false;
  isMVPoleRetagAllowed: boolean = false;
  isMVPoleApproveRejectAllowed: boolean = false;
  isMVPoleAuditReviewAllowed: boolean = false;
  isMVPoleRecallAssignedAllowed: boolean = false;
  isMVPoleRecallValidatedAllowed: boolean = false;
  isMVPoleDownloadAllowed: boolean = false;
  isBuildingDeleteAllowed: boolean = false;
  isBuildingDownloadAllowed: boolean = false;
  isSurveyCreateEditAllowed: boolean = false;
  isMetersCreateEditAllowed: boolean = false;
  isMetersDeleteAllowed: boolean = false;
  isMetersApproveRejectAllowed: boolean = false;
  isMetersRetagAllowed: boolean = false;
  isMetersDownloadAllowed: boolean = false;
  isSurveyDeleteAllowed: boolean = false;
  isSurveyApproveRejectAllowed: boolean = false;
  isSurveyRecallApprovedAllowed: boolean = false;
  isSurveyRecallRejectedAllowed: boolean = false;
  isSurveyCreateNewAllowed: boolean = false;
  isSurveyAssignMapVendorAllowed: boolean = false;
  isSurveyAssignToVendorAllowed: boolean = false;
  isInstallationCreateEditAllowed: boolean = false;
  isInstallationDeleteAllowed: boolean = false;
  isInstallationApproveRejectAllowed: boolean = false;
  isInstallationRecallAllowed: boolean = false;
  isReportMisalignedAllowed: boolean = false;
  isReportDataQualityRejectionAllowed: boolean = false;
  isReportRegularizationAllowed: boolean = false;
  isUserManagementCreateEditAllowed: boolean = false;
  isUserManagementDeleteAllowed: boolean = false;
  isUserManagementBulkAssignAllowed: boolean = false;
  isRoleManagementCreateEditAllowed: boolean = false;
  isRoleManagementDeleteAllowed: boolean = false;
  isUserManagementDownloadAllowed: boolean = false;
  isF33CreateEditAllowed: boolean = false;
  isTsDeleteAllowed: boolean = false;
  isF33DeleteAllowed: boolean = false;
  isSsCreateEditAllowed: boolean = false;
  isSsDeleteAllowed: boolean = false;
  isF11CreateEditAllowed: boolean = false;
  isF11DeleteAllowed: boolean = false;
  isRegionCreateEditAllowed: boolean = false;
  isRegionDeleteAllowed: boolean = false;
  isMeterTypeCreateEditAllowed: boolean = false;
  isMeterTypeDeleteAllowed: boolean = false;
  isTariffCreateEditAllowed: boolean = false;
  isTariffDeleteAllowed: boolean = false;
  isF11ViewAllowed: boolean = false;
  isDisconnectionAllowed: boolean = false;
  isOutagesAllowed: boolean = false;
  isF33ViewAllowed: boolean = false;
  isTransformersViewAllowed: boolean = false;
  isBuildingViewAllowed: boolean = false;
  isMetersViewAllowed: boolean = false;
  isPoleViewAllowed: boolean = false;
  isSurveyViewAllowed: boolean = false;
  isInstallationViewAllowed: boolean = false;
  isTsViewAllowed: boolean = false;
  isSsViewAllowed: boolean = false;
  isTransformersViewCrudAllowed: boolean = false;
  isAreaViewAllowed: boolean = false;
  isRegionViewAllowed: boolean = false;
  isTariffViewAllowed: boolean = false;
  isUserManagementViewAllowed: boolean = false;
  isRoleManagementViewAllowed: boolean = false;
  isMeterTypeViewAllowed: boolean = false;
  isAssetRatingViewAllowed: boolean = false;
  isMeterPriceViewAllowed: boolean = false;
  isAssetStatusViewAllowed: boolean = false;
  isCustomerCrudViewAllowed: boolean = false;
  isDtMeterTypeViewAllowed: boolean = false;
  isAuditLogViewAllowed: boolean = false;
  isAuditLogDownloadAllowed: boolean = false;
  isBuildingCreateEditAllowed: boolean = false;
  isBuildingRecallAssignedAllowed: boolean = false;
  isBuildingRecallValidatedAllowed: boolean = false;
  isBuildingApproveRejectAllowed: boolean = false;
  isBuildingReviewAllowed: boolean = false;
  isBuildingAuditReviewAllowed: boolean = false;
  isBuildingAssignAllowed: boolean = false;
  isBuildingRetagAllowed: boolean = false;
  isBuildingElectricalAddressCodeAllowed: boolean = false;
  isBuildingPropertyCodeAllowed: boolean = false;
  isValidationStatusAllowed: boolean = false;
  isAuditStatusAllowed: boolean = false;
  isReviewStatusAllowed: boolean = false;
  isSiteVerificationAllowed: boolean = false;
  isAreaCreateEditAllowed: boolean = false;
  isAreaDeleteAllowed: boolean = false;
  isAssetRatingCreateEditAllowed: boolean = false;
  isMeterPriceCreateEditAllowed: boolean = false;
  isTsCreateEditAllowed: boolean = false;
  isAssetRatingDeleteAllowed: boolean = false;
  isMeterPriceDeleteAllowed: boolean = false;
  isCreateOrganizationAllowed: boolean = false;
  isPaymentHistoryViewAllowed: boolean = false;
  isPaymentHistoryDownloadAllowed: boolean = false;
  isSettlementViewAllowed: boolean = false;
  isSettlementDownloadAllowed: boolean = false;

  isAssetStatusCreateEditAllowed: boolean = false;
  isAssetStatusDeleteAllowed: boolean = false;
  isCustomerCreateEditCrudAllowed: boolean = false;
  isCustomerAssignForDecommissionAllowed: boolean = false;
  isCustomerDeleteAllowed: boolean = false;
  isCustomerCrudDownloadAllowed: boolean = false;
  isTransformersCreateEditCrudAllowed: boolean = false;
  isTransformersDeleteAllowed: boolean = false;
  isDtMeterTypeCreateEditAllowed: boolean = false;
  isDtMeterTypeDeleteAllowed: boolean = false;
  isWorkOrderMaintenanceAllowed: boolean = false;
  isSltViewAllowed: boolean = false;
  isSltCreateEditAllowed: boolean = false;
  isSltDeleteAllowed: boolean = false;
  isCustomerRegularizationAllowed: boolean = false;
  isCustomerServiceRequestViewCrudAllowed: boolean = false;
  isCustomerNewEntryViewCrudAllowed: boolean = false;
  isCustomerFailedSyncNotificationAllowed: boolean = false;
  isCustomerFeederBandAlignmentNotificationAllowed: boolean = false;

  isCustomerMeterStockInventoryViewAllowed: boolean = false;
  isCustomerMeterStockInventoryCreateAllowed: boolean = false;
  isCustomerMeterStockInventoryViewUtilizationStockAllowed: boolean = false;

  isDashboardAnalyticsOverviewAllowed: boolean = false;
  isDashboardOperationsAnalyticsAllowed: boolean = false;
  isDashboardMeterValidationAllowed: boolean = false;

  isCustomerDecommissionedMeterStockViewAllowed: boolean = false;
  isCustomerDecommissionedMeterStockApproveAllowed: boolean = false;
  isCustomerDecommissionedMeterStockEditAllowed: boolean = false;

  isAssetMeterStockInventoryViewAllowed: boolean = false;
  isAssetMeterStockInventoryCreateAllowed: boolean = false;
  isAssetMeterStockInventoryViewUtilizationStockAllowed: boolean = false;

  isCtvtMeterStockInventoryViewAllowed: boolean = false;
  isCtvtMeterStockInventoryCreateAllowed: boolean = false;
  isCtvtMeterStockInventoryViewUtilizationStockAllowed: boolean = false;

  isDtMeterInstallationViewAllowed: boolean = false;
  isDtMeterInstallationCreateEditAllowed: boolean = false;
  isDtMeterInstallationDeleteAllowed: boolean = false;
  isDtMeterInstallationApproveRejectAllowed: boolean = false;
  isDtMeterInstallationRecallAllowed: boolean = false;
  isDtMeterInstallationAcceptDeclineAllowed: boolean = false;
  isDtMeterInstallationApproveMeterAllowed: boolean = false;
  isDtMeterInstallationApproveInvoiceAllowed: boolean = false;
  isDtMeterInstallationRecallAwaitingApprovalAllowed: boolean = false;
  isDtMeterInstallationAcknowledgeRepaymentAllowed: boolean = false;
  isDtMeterInstallationViewMeterApprovalAllowed: boolean = false;
  isDtMeterInstallationViewInvoiceApprovalAllowed: boolean = false;
  isDtMeterInstallationViewActiveRepaymentAllowed: boolean = false;
  isDtMeterInstallationViewCompletedPaymentAllowed: boolean = false;
  isDtMeterInstallationAuthorizeMeteringAllowed: boolean = false;
  isDtMeterInstallationVendorAssignmentAllowed: boolean = false;
  isDtMeterInstallationDeclineReportAllowed: boolean = false;

  isMeterReadingAllowed: boolean = false;

  isBillingAccountsCreateEditAllowed: boolean = false;
  isBillingAccountsViewAllowed: boolean = false;
  isBillingAccountsDeleteAllowed: boolean = false;

  isBuildingSweepAllowed: boolean = false;
  isPoleSweepAllowed: boolean = false;
  isCustomerSweepAllowed: boolean = false;
  // Permissions related to the utility
  hasDashboardConfigBuildings: boolean = false;
  hasDashboardConfigFeeders: boolean = false;
  hasDashboardConfigSettlement: boolean = false;
  hasDashboardConfigDTS: boolean = false;
  hasDashboardConfigMeters: boolean = false;
  hasDashboardConfigPoles: boolean = false;
  hasDashboardConfigMVPoles: boolean = false;
  hasDashboardConfigSurvey: boolean = false;
  hasDashboardConfigInstallation: boolean = false;
  hasDashboardConfigWorkOrder: boolean = false;
  hasDashboardConfigMeterCustomers: boolean = false;
  hasDashboardConfigMeterAssets: boolean = false;
  hasDashboardConfigMeterCtvt: boolean = false;
  hasDashboardConfigDtMeterInstallation: boolean = false;
  hasDashboardConfigMeterApprovalAndRepayment: boolean = false;
  get hasAnyMeterManagement(): boolean {
    return this.hasDashboardConfigMeterCustomers
      || this.hasDashboardConfigMeterAssets
      || this.hasDashboardConfigMeterCtvt;
  }
  hasDashboardConfigCustomerManagement: boolean = false;
  hasDashboardConfigBillingIntegration: boolean = false;
  hasDashboardConfigReadings: boolean = false;
  hasDashboardConfigMap: boolean = false; //Advanced Map
  hasDashboardConfigRmus: boolean = false;
  hasDashboardConfigNewService: boolean = false;
  hasDashboardConfigMeterValidation: boolean = false;
  hasDashboardConfigAIDroneMap: boolean = false;
  hasDashboardConfigNetworkModelStructure: boolean = false;
  hasDashboardConfigNetworkEntityClassInstantiation: boolean = false;
  hasDashboardConfigDataModelCustomization: boolean = false;
  hasDashboardConfigInjectionSubstation: boolean = false;
  hasDashboardConfigFeederBands: boolean = false;
  hasDashboardConfigPaymentHistory: boolean = false;
  hasDashboardConfigCIMDataIntegration: boolean = false;
  hasDashboardConfigAiWidget: boolean = false;
  // NEW
  isCustomerElectricalAddressCodeAllowed: boolean = false;
  isCustomerPropertyCodeAllowed: boolean = false;
  isTransformersReviewAllowed: boolean = false;
  isRmusViewAllowed: boolean = false;
  isRmusViewCrudAllowed: boolean = false;
  isRmusCreateEditAllowed: boolean = false;
  isRmusCreateEditCrudAllowed: boolean = false;
  isRmusDeleteAllowed: boolean = false;
  isRmusAssignAllowed: boolean = false;
  isRmusApproveRejectAllowed: boolean = false;
  isRmusAuditReviewAllowed: boolean = false;
  isRmusRecallAssignedAllowed: boolean = false;
  isRmuRecallValidatedAllowed: boolean = false;
  isRmuRetagAllowed: boolean = false;
  isRmuDownloadAllowed: boolean = false;
  isPoleReviewAllowed: boolean = false;
  isNewServiceViewAllowed: boolean = false;
  isNewServiceCreateEditAllowed: boolean = false;
  isNewServiceDownloadAllowed: boolean = false;
  isNewServiceDeleteAllowed: boolean = false;
  isNewServiceApproveRejectAllowed: boolean = false;
  isNewServiceBulkUploadAllowed: boolean = false;
  isNewServiceRecallValidatedAllowed: boolean = false;
  isSiteVerificationCreateEditAllowed: boolean = false;
  isSiteVerificationDownloadAllowed: boolean = false;
  isSiteVerificationValidationAllowed: boolean = false;
  isSiteVerificationRecallAssignedAllowed: boolean = false;
  isSiteVerificationRecallValidatedAllowed: boolean = false;
  isSiteVerificationSiteVerificationAllowed: boolean = false;
  isSiteVerificationViewAllowed: boolean = false;
  isSiteVerificationApproveRejectAllowed: boolean = false;
  isServiceRequestAuthViewAllowed: boolean = false;
  isServiceRequestAuthCreateEditAllowed: boolean = false;
  isServiceRequestAuthDownloadAllowed: boolean = false;
  isServiceRequestAuthBulkUploadAllowed: boolean = false;
  isServiceRequestAuthValidationAllowed: boolean = false;
  isOnboardedCustomersViewAllowed: boolean = false;
  isOnboardedCustomersCreateEditAllowed: boolean = false;
  isOnboardedCustomersDownloadAllowed: boolean = false;
  isOnboardedCustomersAssignToVendorAllowed: boolean = false;
  isMeterValidationViewAllowed: boolean = false;
  isMeterValidationCreateEditAllowed: boolean = false;
  isMeterValidationApproveRejectAllowed: boolean = false;
  hasDashboardConfigEnergySources: boolean = false;
  meterValidationTamperEnabled: boolean = false;
  accountCreationEnabled: boolean = false;
  dtConfirmationEnabled: boolean = false;
  isAIUAVOverviewAllowed: boolean = false;
  isAIUAVBatchImageImportAllowed: boolean = false;
  isAIUAVSegmentationListAllowed: boolean = false;
  isAIUAVJobMonitoringAllowed: boolean = false;
  isReadingsAllowed: boolean = false;
  isNetworkStructureViewAllowed: boolean = false;
  isNetworkStructureCreateEditAllowed: boolean = false;
  isNetworkStructureAssignAllowed: boolean = false;
  isNetworkStructureApproveRejectAllowed: boolean = false;
  isNetworkStructureReviewAllowed: boolean = false;
  isNetworkStructureAuditReviewAllowed: boolean = false;
  isNetworkStructureRecallValidatedAllowed: boolean = false;
  isNetworkStructureRecallAssignedAllowed: boolean = false;
  isNetworkStructureDownloadAllowed: boolean = false;
  isNetworkStructureDeleteAllowed: boolean = false;
  isNetworkStructureGisReviewAllowed: boolean = false;
  isNetworkEntityClassesViewAllowed: boolean = false;
  isNetworkEntityClassesCreateEditAllowed: boolean = false;
  isNetworkEntityClassesDeleteAllowed: boolean = false;
  isSchematicDiagramViewAllowed: boolean = false;
  isSchematicDiagramCreateEditAllowed: boolean = false;
  isDataModelCustomizationViewAllowed: boolean = false;
  isMeterAssignmentViewAllowed: boolean = false;
  isMeterAssignmentCreateEditAllowed: boolean = false;
  isMeterAssignmentDeleteAllowed: boolean = false;
  isServiceRequestTrackerViewAllowed: boolean = false;
  isAuditTrailViewAllowed: boolean = false;
  isAuditTrailDownloadAllowed: boolean = false;

  private jwtService = new JwtHelperService();

  constructor(
    private toastr: ToastrService,
    private roleService: RoleService,
  ) {
    this.initializePermissions();
  }

  initializePermissions() {
    this.resetPermissions();
    this.hasUtility = Boolean(this.checkIfhasUtility());
    this.initializeRolePermissions();
    this.initializeDashboardConfigPermissions();
  }

  resetPermissions() {
    this.isNewServiceViewAllowed = false;
    this.isNewServiceCreateEditAllowed = false;
    this.isNewServiceDownloadAllowed = false;
    this.isNewServiceDeleteAllowed = false;
    this.isNewServiceApproveRejectAllowed = false;
    this.isNewServiceBulkUploadAllowed = false;
    this.isNewServiceRecallValidatedAllowed = false;
    this.isSiteVerificationCreateEditAllowed = false;
    this.isSiteVerificationDownloadAllowed = false;
    this.isSiteVerificationValidationAllowed = false;
    this.isSiteVerificationRecallAssignedAllowed = false;
    this.isSiteVerificationRecallValidatedAllowed = false;
    this.isSiteVerificationSiteVerificationAllowed = false;
    this.isSiteVerificationViewAllowed = false;
    this.isSiteVerificationApproveRejectAllowed = false;
    this.isServiceRequestAuthViewAllowed = false;
    this.isServiceRequestAuthCreateEditAllowed = false;
    this.isServiceRequestAuthDownloadAllowed = false;
    this.isServiceRequestAuthBulkUploadAllowed = false;
    this.isServiceRequestAuthValidationAllowed = false;
    this.isOnboardedCustomersViewAllowed = false;
    this.isOnboardedCustomersCreateEditAllowed = false;
    this.isOnboardedCustomersDownloadAllowed = false;
    this.isOnboardedCustomersAssignToVendorAllowed = false;
    this.isRmusViewAllowed = false;
    this.isRmusViewCrudAllowed = false;
    this.isRmusCreateEditAllowed = false;
    this.isRmusCreateEditCrudAllowed = false;
    this.isRmusDeleteAllowed = false;
    this.isRmusAssignAllowed = false;
    this.isRmusApproveRejectAllowed = false;
    this.isRmusAuditReviewAllowed = false;
    this.isRmusRecallAssignedAllowed = false;
    this.isRmuRecallValidatedAllowed = false;
    this.isRmuRetagAllowed = false;
    this.isCustomerCreateEditAllowed = false;
    this.isPoleReviewAllowed = false;
    this.isTransformersReviewAllowed = false;
    this.hasDashboardConfigEnergySources = false;
    this.meterValidationTamperEnabled = false;
    this.accountCreationEnabled = false;
    this.dtConfirmationEnabled = false;
    this.isCustomerElectricalAddressCodeAllowed = false;
    this.isCustomerPropertyCodeAllowed = false;
    this.isDashboardAnalyticsOverviewAllowed = false;
    this.isMeterValidationApproveRejectAllowed = false;
    this.isDashboardOperationsAnalyticsAllowed = false;
    this.isDashboardMeterValidationAllowed = false;
    this.isMeterValidationCreateEditAllowed = false;
    this.isMeterValidationViewAllowed = false;

    this.isRmuDownloadAllowed = false;
    this.hasUtility = false;
    this.isMapViewAllowed = false;
    this.isCustomerViewAllowed = false;
    this.isF11ViewAllowed = false;
    this.isF33ViewAllowed = false;
    this.isTransformersViewAllowed = false;
    this.isBuildingViewAllowed = false;
    this.isMetersViewAllowed = false;
    this.isPoleViewAllowed = false;
    this.isSurveyViewAllowed = false;
    this.isInstallationViewAllowed = false;
    this.isTsViewAllowed = false;
    this.isSsViewAllowed = false;
    this.isTransformersViewCrudAllowed = false;
    this.isAreaViewAllowed = false;
    this.isRegionViewAllowed = false;
    this.isTariffViewAllowed = false;
    this.isUserManagementViewAllowed = false;
    this.isRoleManagementViewAllowed = false;
    this.isMeterTypeViewAllowed = false;
    this.isAssetRatingViewAllowed = false;
    this.isMeterPriceViewAllowed = false;
    this.isAssetStatusViewAllowed = false;
    this.isCustomerCrudViewAllowed = false;
    this.isDtMeterTypeViewAllowed = false;
    this.isAuditLogViewAllowed = false;
    this.isAuditLogDownloadAllowed = false;
    this.isBuildingCreateEditAllowed = false;
    this.isBuildingRecallAssignedAllowed = false;
    this.isBuildingRecallValidatedAllowed = false;
    this.isBuildingApproveRejectAllowed = false;
    this.isBuildingReviewAllowed = false;
    this.isBuildingAuditReviewAllowed = false;
    this.isBuildingAssignAllowed = false;
    this.isBuildingRetagAllowed = false;
    this.isBuildingElectricalAddressCodeAllowed = false;
    this.isBuildingPropertyCodeAllowed = false;
    this.isValidationStatusAllowed = false;
    this.isAuditStatusAllowed = false;
    this.isReviewStatusAllowed = false;
    this.isSiteVerificationAllowed = false;
    this.isAreaCreateEditAllowed = false;
    this.isAreaDeleteAllowed = false;
    this.isAssetRatingCreateEditAllowed = false;
    this.isMeterPriceCreateEditAllowed = false;
    this.isTsCreateEditAllowed = false;
    this.isAssetStatusCreateEditAllowed = false;
    this.isAssetStatusDeleteAllowed = false;
    this.isCustomerCreateEditCrudAllowed = false;
    this.isCustomerDeleteAllowed = false;
    this.isTransformersCreateEditCrudAllowed = false;
    this.isTransformersDeleteAllowed = false;
    this.isDtMeterTypeCreateEditAllowed = false;
    this.isDtMeterTypeDeleteAllowed = false;
    this.isCustomerAssignAllowed = false;
    this.isCustomerRetagAllowed = false;
    this.isCustomerApproveRejectAllowed = false;
    this.isCustomerReviewAllowed = false;
    this.isCustomerAuditReviewAllowed = false;
    this.isCustomerRecallAssignedAllowed = false;
    this.isCustomerRecallValidatedAllowed = false;
    this.isCustomerUnvisitedAllowed = false;
    this.isCustomerNewEntryBreakdownAllowed = false;
    this.isTransformersCreateEditAllowed = false;
    this.isTransformersAssignAllowed = false;
    this.isTransformersRetagAllowed = false;
    this.isTransformersApproveRejectAllowed = false;
    this.isTransformersRecallAssignedAllowed = false;
    this.isTransformersRecallValidatedAllowed = false;
    this.isPoleCreateEditAllowed = false;
    this.isPoleDeleteAllowed = false;
    this.isPoleApproveRejectAllowed = false;
    this.isPoleAuditReviewAllowed = false;
    this.isPoleRecallAssignedAllowed = false;
    this.isPoleRecallValidatedAllowed = false;
    this.isMVPoleViewAllowed = false;
    this.isMVPoleCreateEditAllowed = false;
    this.isMVPoleDeleteAllowed = false;
    this.isMVPoleAssignAllowed = false;
    this.isMVPoleApproveRejectAllowed = false;
    this.isMVPoleAuditReviewAllowed = false;
    this.isMVPoleRecallAssignedAllowed = false;
    this.isMVPoleRetagAllowed = false;
    this.isMVPoleRecallValidatedAllowed = false;
    this.isMVPoleDownloadAllowed = false;
    this.isBuildingDeleteAllowed = false;
    this.isSurveyCreateEditAllowed = false;
    this.isMetersCreateEditAllowed = false;
    this.isMetersDeleteAllowed = false;
    this.isMetersApproveRejectAllowed = false;
    this.isMetersRetagAllowed = false;
    this.isSurveyApproveRejectAllowed = false;
    this.isSurveyRecallApprovedAllowed = false;
    this.isSurveyRecallRejectedAllowed = false;
    this.isSurveyDeleteAllowed = false;
    this.isSurveyCreateNewAllowed = false;
    this.isSurveyAssignMapVendorAllowed = false;
    this.isSurveyAssignToVendorAllowed = false;
    this.isInstallationCreateEditAllowed = false;
    this.isInstallationDeleteAllowed = false;
    this.isInstallationApproveRejectAllowed = false;
    this.isInstallationRecallAllowed = false;
    this.isReportMisalignedAllowed = false;
    this.isReportDataQualityRejectionAllowed = false;
    this.isReportRegularizationAllowed = false;
    this.isUserManagementDeleteAllowed = false;
    this.isUserManagementBulkAssignAllowed = false;
    this.isRoleManagementCreateEditAllowed = false;
    this.isRoleManagementDeleteAllowed = false;
    this.isUserManagementDownloadAllowed = false;
    this.isTsDeleteAllowed = false;
    this.isF33CreateEditAllowed = false;
    this.isF33DeleteAllowed = false;
    this.isSsCreateEditAllowed = false;
    this.isSsDeleteAllowed = false;
    this.isF11CreateEditAllowed = false;
    this.isF11DeleteAllowed = false;
    this.isRegionCreateEditAllowed = false;
    this.isRegionDeleteAllowed = false;
    this.isMeterTypeCreateEditAllowed = false;
    this.isMeterTypeDeleteAllowed = false;
    this.isTariffCreateEditAllowed = false;
    this.isTariffDeleteAllowed = false;
    this.isTransformersAuditReviewAllowed = false;
    this.isUserManagementCreateEditAllowed = false;
    this.isDisconnectionAllowed = false;
    this.isOutagesAllowed = false;
    this.isAssetRatingDeleteAllowed = false;
    this.isMeterPriceDeleteAllowed = false;
    this.isCustomerRegularizationAllowed = false;
    this.isCustomerServiceRequestViewCrudAllowed = false;
    this.isCustomerNewEntryViewCrudAllowed = false;
    this.isCustomerFailedSyncNotificationAllowed = false;
    this.isCustomerFeederBandAlignmentNotificationAllowed = false;

    this.isSltViewAllowed = false;
    this.isSltCreateEditAllowed = false;
    this.isSltDeleteAllowed = false;
    this.isCreateOrganizationAllowed = false;
    this.isPaymentHistoryViewAllowed = false;
    this.isPaymentHistoryDownloadAllowed = false;
    this.isSettlementViewAllowed = false;
    this.isSettlementDownloadAllowed = false;

    this.hasDashboardConfigFeeders = false;
    this.hasDashboardConfigSettlement = false;
    this.hasDashboardConfigBuildings = false;
    this.hasDashboardConfigDTS = false;
    this.hasDashboardConfigMeters = false;
    this.hasDashboardConfigPoles = false;
    this.hasDashboardConfigMVPoles = false;
    this.hasDashboardConfigSurvey = false;
    this.hasDashboardConfigInstallation = false;
    this.hasDashboardConfigWorkOrder = false;
    this.isWorkOrderMaintenanceAllowed = false;
    this.hasDashboardConfigMeterCustomers = false;
    this.hasDashboardConfigMeterAssets = false;
    this.hasDashboardConfigMeterCtvt = false;
    this.hasDashboardConfigDtMeterInstallation = false;
    this.hasDashboardConfigMeterApprovalAndRepayment = false;
    this.hasDashboardConfigCustomerManagement = false;
    this.hasDashboardConfigBillingIntegration = false;
    this.hasDashboardConfigReadings = false;
    this.hasDashboardConfigMap = false;
    this.hasDashboardConfigRmus = false;
    this.hasDashboardConfigNewService = false;
    this.hasDashboardConfigMeterValidation = false;
    this.hasDashboardConfigFeederBands = false;
    this.hasDashboardConfigPaymentHistory = false;
    this.hasDashboardConfigCIMDataIntegration = false;
    this.hasDashboardConfigAiWidget = false;

    this.isCustomerAssignForDecommissionAllowed = false;
    this.isCustomerMeterStockInventoryViewAllowed = false;
    this.isCustomerMeterStockInventoryCreateAllowed = false;
    this.isCustomerMeterStockInventoryViewUtilizationStockAllowed = false;

    this.isCustomerDecommissionedMeterStockViewAllowed = false;
    this.isCustomerDecommissionedMeterStockApproveAllowed = false;
    this.isCustomerDecommissionedMeterStockEditAllowed = false;

    this.isAssetMeterStockInventoryViewAllowed = false;
    this.isAssetMeterStockInventoryCreateAllowed = false;
    this.isAssetMeterStockInventoryViewUtilizationStockAllowed = false;

    this.isCtvtMeterStockInventoryViewAllowed = false;
    this.isCtvtMeterStockInventoryCreateAllowed = false;
    this.isCtvtMeterStockInventoryViewUtilizationStockAllowed = false;

    this.isDtMeterInstallationViewAllowed = false;
    this.isDtMeterInstallationCreateEditAllowed = false;
    this.isDtMeterInstallationDeleteAllowed = false;
    this.isDtMeterInstallationApproveRejectAllowed = false;
    this.isDtMeterInstallationRecallAllowed = false;
    this.isDtMeterInstallationAcceptDeclineAllowed = false;
    this.isDtMeterInstallationApproveMeterAllowed = false;
    this.isDtMeterInstallationApproveInvoiceAllowed = false;
    this.isDtMeterInstallationRecallAwaitingApprovalAllowed = false;
    this.isDtMeterInstallationAcknowledgeRepaymentAllowed = false;
    this.isDtMeterInstallationViewMeterApprovalAllowed = false;
    this.isDtMeterInstallationViewInvoiceApprovalAllowed = false;
    this.isDtMeterInstallationViewActiveRepaymentAllowed = false;
    this.isDtMeterInstallationViewCompletedPaymentAllowed = false;
    this.isDtMeterInstallationAuthorizeMeteringAllowed = false;
    this.isDtMeterInstallationVendorAssignmentAllowed = false;
    this.isDtMeterInstallationDeclineReportAllowed = false;

    this.isMeterReadingAllowed = false;

    this.isBillingAccountsCreateEditAllowed = false;
    this.isBillingAccountsDeleteAllowed = false;
    this.isBillingAccountsViewAllowed = false;

    this.isBuildingDownloadAllowed = false;
    this.isTransformersDownloadAllowed = false;
    this.isPoleDownloadAllowed = false;
    this.isCustomerDownloadAllowed = false;
    this.isCustomerCrudDownloadAllowed = false;
    this.isMetersDownloadAllowed = false;
    this.isPoleSweepAllowed = false;
    this.isBuildingSweepAllowed = false;
    this.isCustomerSweepAllowed = false;
    this.hasDashboardConfigAIDroneMap = false;
    this.hasDashboardConfigNetworkModelStructure = false;
    this.hasDashboardConfigNetworkEntityClassInstantiation = false;
    this.hasDashboardConfigDataModelCustomization = false;
    this.hasDashboardConfigInjectionSubstation = false;
    this.isAIUAVOverviewAllowed = false;
    this.isAIUAVBatchImageImportAllowed = false;
    this.isAIUAVSegmentationListAllowed = false;
    this.isAIUAVJobMonitoringAllowed = false;
    this.isReadingsAllowed = false;
    this.isNetworkStructureViewAllowed = false;
    this.isNetworkStructureCreateEditAllowed = false;
    this.isNetworkStructureAssignAllowed = false;
    this.isNetworkStructureApproveRejectAllowed = false;
    this.isNetworkStructureReviewAllowed = false;
    this.isNetworkStructureAuditReviewAllowed = false;
    this.isNetworkStructureRecallValidatedAllowed = false;
    this.isNetworkStructureRecallAssignedAllowed = false;
    this.isNetworkStructureDownloadAllowed = false;
    this.isNetworkStructureDeleteAllowed = false;
    this.isNetworkStructureGisReviewAllowed = false;
    this.isNetworkEntityClassesViewAllowed = false;
    this.isNetworkEntityClassesCreateEditAllowed = false;
    this.isNetworkEntityClassesDeleteAllowed = false;
    this.isSchematicDiagramViewAllowed = false;
    this.isSchematicDiagramCreateEditAllowed = false;
    this.isDataModelCustomizationViewAllowed = false;
    this.isMeterAssignmentViewAllowed = false;
    this.isMeterAssignmentCreateEditAllowed = false;
    this.isMeterAssignmentDeleteAllowed = false;
    this.isServiceRequestTrackerViewAllowed = false;
    this.isAuditTrailViewAllowed = false;
    this.isAuditTrailDownloadAllowed = false;
  }

  private isWellFormedJwt(token: string | null): token is string {
    return !!token && token.split('.').length === 3;
  }

  checkIfhasUtility() {
    let token = localStorage.getItem('token');
    if (!this.isWellFormedJwt(token)) return null;

    let currentUser = this.jwtService.decodeToken(token);
    return currentUser.utilityId != '';
  }

  getPermissions() {
    return this.roleService.getPermissions().pipe(
      tap((response) => {
        if (response.status === 200) {
          localStorage.setItem(
            'permissions',
            JSON.stringify(response.body?.data),
          );
          this.initializePermissions();
        }
      }),
    );
  }

  initializeRolePermissions() {
    let rolePermissions = localStorage.getItem('permissions');

    if (!rolePermissions) {
      return;
    }

    let permissions: number[] = rolePermissions
      ? JSON.parse(rolePermissions)
      : [];

    for (let index = 0; index < permissions.length; index++) {
      const permission: number = permissions[index];
      // console.log('PermissionsService permission', PermissionsEnum[permission]);

      switch (permission) {
        case PermissionsEnum.NewService_View:
          this.isNewServiceViewAllowed = true;
          break;
        case PermissionsEnum.NewService_CreateEdit:
          this.isNewServiceCreateEditAllowed = true;
          break;
        case PermissionsEnum.NewService_Download:
          this.isNewServiceDownloadAllowed = true;
          break;
        case PermissionsEnum.NewService_ApproveReject:
          this.isNewServiceApproveRejectAllowed = true;
          break;
        case PermissionsEnum.NewService_Delete:
          this.isNewServiceDeleteAllowed = true;
          break;
        case PermissionsEnum.NewService_BulkUpload:
          this.isNewServiceBulkUploadAllowed = true;
          break;
        case PermissionsEnum.NewService_RecallValidated:
          this.isNewServiceRecallValidatedAllowed = true;
          break;
        case PermissionsEnum.SiteVerification_CreateEdit:
          this.isSiteVerificationCreateEditAllowed = true;
          break;
        case PermissionsEnum.SiteVerification_Download:
          this.isSiteVerificationDownloadAllowed = true;
          break;
        case PermissionsEnum.SiteVerification_Validation:
          this.isSiteVerificationValidationAllowed = true;
          break;
        case PermissionsEnum.SiteVerification_RecallAssigned:
          this.isSiteVerificationRecallAssignedAllowed = true;
          break;
        case PermissionsEnum.SiteVerification_RecallValidated:
          this.isSiteVerificationRecallValidatedAllowed = true;
          break;
        case PermissionsEnum.SiteVerification_SiteVerification:
          this.isSiteVerificationSiteVerificationAllowed = true;
          break;
        case PermissionsEnum.SiteVerification_View:
          this.isSiteVerificationViewAllowed = true;
          break;
        case PermissionsEnum.SiteVerification_ApproveReject:
          this.isSiteVerificationApproveRejectAllowed = true;
          break;
        case PermissionsEnum.ServiceRequestAuth_View:
          this.isServiceRequestAuthViewAllowed = true;
          break;
        case PermissionsEnum.ServiceRequestAuth_CreateEdit:
          this.isServiceRequestAuthCreateEditAllowed = true;
          break;
        case PermissionsEnum.ServiceRequestAuth_Download:
          this.isServiceRequestAuthDownloadAllowed = true;
          break;
        case PermissionsEnum.ServiceRequestAuth_BulkUpload:
          this.isServiceRequestAuthBulkUploadAllowed = true;
          break;
        case PermissionsEnum.ServiceRequestAuth_Validation:
          this.isServiceRequestAuthValidationAllowed = true;
          break;
        case PermissionsEnum.OnboardedCustomers_View:
          this.isOnboardedCustomersViewAllowed = true;
          break;
        case PermissionsEnum.OnboardedCustomers_CreateEdit:
          this.isOnboardedCustomersCreateEditAllowed = true;
          break;
        case PermissionsEnum.OnboardedCustomers_Download:
          this.isOnboardedCustomersDownloadAllowed = true;
          break;
        case PermissionsEnum.OnboardedCustomers_AssignToVendor:
          this.isOnboardedCustomersAssignToVendorAllowed = true;
          break;
        case PermissionsEnum.Rmus_View:
          this.isRmusViewAllowed = true;
          break;
        case PermissionsEnum.Rmus_ViewCrud:
          this.isRmusViewCrudAllowed = true;
          break;
        case PermissionsEnum.Rmus_CreateEdit:
          this.isRmusCreateEditAllowed = true;
          break;
        case PermissionsEnum.Rmus_CreateEditCrud:
          this.isRmusCreateEditCrudAllowed = true;
          break;
        case PermissionsEnum.Rmus_Delete:
          this.isRmusDeleteAllowed = true;
          break;
        case PermissionsEnum.Rmus_Assign:
          this.isRmusAssignAllowed = true;
          break;
        case PermissionsEnum.Rmus_ApproveReject:
          this.isRmusApproveRejectAllowed = true;
          break;
        case PermissionsEnum.Rmus_AuditReview:
          this.isRmusAuditReviewAllowed = true;
          break;
        case PermissionsEnum.Rmus_RecallAssigned:
          this.isRmusRecallAssignedAllowed = true;
          break;
        case PermissionsEnum.Rmus_RecallValidated:
          this.isRmuRecallValidatedAllowed = true;
          break;
        case PermissionsEnum.Rmus_Retag:
          this.isRmuRetagAllowed = true;
          break;
        case PermissionsEnum.Rmus_Download:
          this.isRmuDownloadAllowed = true;
          break;
        case PermissionsEnum.Customer_View:
          this.isCustomerViewAllowed = true;
          break;
        case PermissionsEnum.Customer_CreateEdit:
          this.isCustomerCreateEditAllowed = true;
          break;
        case PermissionsEnum.Customer_CreateEditCrud:
          this.isCustomerCreateEditCrudAllowed = true;
          break;
        case PermissionsEnum.Customer_AssignForDecommission:
          this.isCustomerAssignForDecommissionAllowed = true;
          break;
        case PermissionsEnum.Customer_Delete:
          this.isCustomerDeleteAllowed = true;
          break;
        case PermissionsEnum.Customer_Assign:
          this.isCustomerAssignAllowed = true;
          break;
        case PermissionsEnum.Customer_Retag:
          this.isCustomerRetagAllowed = true;
          break;
        case PermissionsEnum.Customer_ApproveReject:
          this.isCustomerApproveRejectAllowed = true;
          break;
        case PermissionsEnum.Customer_Review:
          this.isCustomerReviewAllowed = true;
          break;
        case PermissionsEnum.Customer_AuditReview:
          this.isCustomerAuditReviewAllowed = true;
          break;
        case PermissionsEnum.Customer_RecallAssigned:
          this.isCustomerRecallAssignedAllowed = true;
          break;
        case PermissionsEnum.Customer_RecallValidated:
          this.isCustomerRecallValidatedAllowed = true;
          break;
        case PermissionsEnum.Dashboard_AnalyticsOverview:
          this.isDashboardAnalyticsOverviewAllowed = true;
          break;
        case PermissionsEnum.Dashboard_OperationsAnalytics:
          this.isDashboardOperationsAnalyticsAllowed = true;
          break;
        case PermissionsEnum.Customer_ViewCrud:
          this.isCustomerCrudViewAllowed = true;
          break;
        case PermissionsEnum.Customer_Unvisited:
          this.isCustomerUnvisitedAllowed = true;
          break;
        case PermissionsEnum.Customer_NewEntryBreakdown:
          this.isCustomerNewEntryBreakdownAllowed = true;
          break;
        case PermissionsEnum.Customer_Download:
          this.isCustomerDownloadAllowed = true;
          break;
        case PermissionsEnum.Customer_CrudDownload:
          this.isCustomerCrudDownloadAllowed = true;
          break;
        case PermissionsEnum.Customer_ElectricalAddressCode:
          this.isCustomerElectricalAddressCodeAllowed = true;
          break;
        case PermissionsEnum.Customer_PropertyCode:
          this.isCustomerPropertyCodeAllowed = true;
          break;
        case PermissionsEnum.Transformers_CreateEdit:
          this.isTransformersCreateEditAllowed = true;
          break;
        case PermissionsEnum.Transformers_Delete:
          this.isTransformersDeleteAllowed = true;
          break;
        case PermissionsEnum.Transformers_Assign:
          this.isTransformersAssignAllowed = true;
          break;
        case PermissionsEnum.Transformers_Retag:
          this.isTransformersRetagAllowed = true;
          break;
        case PermissionsEnum.Transformers_ApproveReject:
          this.isTransformersApproveRejectAllowed = true;
          break;
        case PermissionsEnum.Transformers_AuditReview:
          this.isTransformersAuditReviewAllowed = true;
          break;
        case PermissionsEnum.Transformers_RecallAssigned:
          this.isTransformersRecallAssignedAllowed = true;
          break;
        case PermissionsEnum.Transformers_RecallValidated:
          this.isTransformersRecallValidatedAllowed = true;
          break;
        case PermissionsEnum.Transformers_ViewCrud:
          this.isTransformersViewCrudAllowed = true;
          break;
        case PermissionsEnum.Transformers_View:
          this.isTransformersViewAllowed = true;
          break;
        case PermissionsEnum.Transformers_CreateEditCrud:
          this.isTransformersCreateEditCrudAllowed = true;
          break;
        case PermissionsEnum.Transformers_Download:
          this.isTransformersDownloadAllowed = true;
          break;
        case PermissionsEnum.Transformers_Review:
          this.isTransformersReviewAllowed = true;
          break;
        case PermissionsEnum.Pole_View:
          this.isPoleViewAllowed = true;
          break;
        case PermissionsEnum.Pole_CreateEdit:
          this.isPoleCreateEditAllowed = true;
          break;
        case PermissionsEnum.Pole_Delete:
          this.isPoleDeleteAllowed = true;
          break;
        case PermissionsEnum.Pole_Assign:
          this.isPoleAssignAllowed = true;
          break;
        case PermissionsEnum.Pole_Retag:
          this.isPoleRetagAllowed = true;
          break;
        case PermissionsEnum.Pole_ApproveReject:
          this.isPoleApproveRejectAllowed = true;
          break;
        case PermissionsEnum.Pole_AuditReview:
          this.isPoleAuditReviewAllowed = true;
          break;
        case PermissionsEnum.Pole_RecallAssigned:
          this.isPoleRecallAssignedAllowed = true;
          break;
        case PermissionsEnum.Pole_RecallValidated:
          this.isPoleRecallValidatedAllowed = true;
          break;
        case PermissionsEnum.Pole_Download:
          this.isPoleDownloadAllowed = true;
          break;
        case PermissionsEnum.Pole_Review:
          this.isPoleReviewAllowed = true;
          break;
        case PermissionsEnum.MVPole_View:
          this.isMVPoleViewAllowed = true;
          break;
        case PermissionsEnum.MVPole_CreateEdit:
          this.isMVPoleCreateEditAllowed = true;
          break;
        case PermissionsEnum.MVPole_Delete:
          this.isMVPoleDeleteAllowed = true;
          break;
        case PermissionsEnum.MVPole_Assign:
          this.isMVPoleAssignAllowed = true;
          break;
        case PermissionsEnum.MVPole_ApproveReject:
          this.isMVPoleApproveRejectAllowed = true;
          break;
        case PermissionsEnum.MVPole_AuditReview:
          this.isMVPoleAuditReviewAllowed = true;
          break;
        case PermissionsEnum.MVPole_RecallAssigned:
          this.isMVPoleRecallAssignedAllowed = true;
          break;
        case PermissionsEnum.MVPole_Retag:
          this.isMVPoleRetagAllowed = true;
          break;
        case PermissionsEnum.MVPole_RecallValidated:
          this.isMVPoleRecallValidatedAllowed = true;
          break;
        case PermissionsEnum.MVPole_Download:
          this.isMVPoleDownloadAllowed = true;
          break;
        case PermissionsEnum.Building_View:
          this.isBuildingViewAllowed = true;
          break;
        case PermissionsEnum.Building_CreateEdit:
          this.isBuildingCreateEditAllowed = true;
          break;
        case PermissionsEnum.Building_Delete:
          this.isBuildingDeleteAllowed = true;
          break;
        case PermissionsEnum.Building_Assign:
          this.isBuildingAssignAllowed = true;
          break;
        case PermissionsEnum.Building_Retag:
          this.isBuildingRetagAllowed = true;
          break;
        case PermissionsEnum.Building_ApproveReject:
          this.isBuildingApproveRejectAllowed = true;
          break;
        case PermissionsEnum.Building_Review:
          this.isBuildingReviewAllowed = true;
          break;
        case PermissionsEnum.Building_AuditReview:
          this.isBuildingAuditReviewAllowed = true;
          break;
        case PermissionsEnum.Building_RecallAssigned:
          this.isBuildingRecallAssignedAllowed = true;
          break;
        case PermissionsEnum.Building_RecallValidated:
          this.isBuildingRecallValidatedAllowed = true;
          break;
        case PermissionsEnum.Building_Download:
          this.isBuildingDownloadAllowed = true;
          break;
        case PermissionsEnum.Building_ElectricalAddressCode:
          this.isBuildingElectricalAddressCodeAllowed = true;
          break;
        case PermissionsEnum.Building_PropertyCode:
          this.isBuildingPropertyCodeAllowed = true;
          break;
        case PermissionsEnum.Survey_CreateEdit:
          this.isSurveyCreateEditAllowed = true;
          break;
        case PermissionsEnum.Survey_Create_New:
          this.isSurveyCreateNewAllowed = true;
          break;
        case PermissionsEnum.Meters_View:
          this.isMetersViewAllowed = true;
          break;
        case PermissionsEnum.Meters_CreateEdit:
          this.isMetersCreateEditAllowed = true;
          break;
        case PermissionsEnum.Meters_Delete:
          this.isMetersDeleteAllowed = true;
          break;
        case PermissionsEnum.Meters_ApproveReject:
          this.isMetersApproveRejectAllowed = true;
          break;
        case PermissionsEnum.Meters_Retag:
          this.isMetersRetagAllowed = true;
          break;
        case PermissionsEnum.Meters_Download:
          this.isMetersDownloadAllowed = true;
          break;
        case PermissionsEnum.Survey_View:
          this.isSurveyViewAllowed = true;
          break;
        case PermissionsEnum.Survey_Delete:
          this.isSurveyDeleteAllowed = true;
          break;
        case PermissionsEnum.Survey_ApproveReject:
          this.isSurveyApproveRejectAllowed = true;
          break;
        case PermissionsEnum.Survey_RecallApproved:
          this.isSurveyRecallApprovedAllowed = true;
          break;
        case PermissionsEnum.Survey_RecallRejected:
          this.isSurveyRecallRejectedAllowed = true;
          break;
        case PermissionsEnum.Survey_AssignMapVendor:
          this.isSurveyAssignMapVendorAllowed = true;
          break;
        case PermissionsEnum.Survey_AssignToVendor:
          this.isSurveyAssignToVendorAllowed = true;
          break;
        case PermissionsEnum.Installation_View:
          this.isInstallationViewAllowed = true;
          break;
        case PermissionsEnum.Installation_CreateEdit:
          this.isInstallationCreateEditAllowed = true;
          break;
        case PermissionsEnum.Installation_Delete:
          this.isInstallationDeleteAllowed = true;
          break;
        case PermissionsEnum.Installation_ApproveReject:
          this.isInstallationApproveRejectAllowed = true;
          break;
        case PermissionsEnum.Installation_Recall:
          this.isInstallationRecallAllowed = true;
          break;
        case PermissionsEnum.Report_Misaligned:
          this.isReportMisalignedAllowed = true;
          break;
        case PermissionsEnum.Report_DataQualityRejection:
          this.isReportDataQualityRejectionAllowed = true;
          break;
        case PermissionsEnum.Report_Regularization:
          this.isReportRegularizationAllowed = true;
          break;
        case PermissionsEnum.UserManagement_View:
          this.isUserManagementViewAllowed = true;
          break;
        case PermissionsEnum.UserManagement_CreateEdit:
          this.isUserManagementCreateEditAllowed = true;
          break;
        case PermissionsEnum.UserManagement_Delete:
          this.isUserManagementDeleteAllowed = true;
          break;
        case PermissionsEnum.UserManagement_BulkAssign:
          this.isUserManagementBulkAssignAllowed = true;
          break;
        case PermissionsEnum.RoleManagement_View:
          this.isRoleManagementViewAllowed = true;
          break;
        case PermissionsEnum.RoleManagement_CreateEdit:
          this.isRoleManagementCreateEditAllowed = true;
          break;
        case PermissionsEnum.RoleManagement_Delete:
          this.isRoleManagementDeleteAllowed = true;
          break;
        case PermissionsEnum.UserManagement_Download:
          this.isUserManagementDownloadAllowed = true;
          break;
        case PermissionsEnum.Ts_View:
          this.isTsViewAllowed = true;
          break;
        case PermissionsEnum.Ts_CreateEdit:
          this.isTsCreateEditAllowed = true;
          break;
        case PermissionsEnum.Ts_Delete:
          this.isTsDeleteAllowed = true;
          break;
        case PermissionsEnum.F33_View:
          this.isF33ViewAllowed = true;
          break;
        case PermissionsEnum.F33_CreateEdit:
          this.isF33CreateEditAllowed = true;
          break;
        case PermissionsEnum.F33_Delete:
          this.isF33DeleteAllowed = true;
          break;
        case PermissionsEnum.Ss_View:
          this.isSsViewAllowed = true;
          break;
        case PermissionsEnum.Ss_CreateEdit:
          this.isSsCreateEditAllowed = true;
          break;
        case PermissionsEnum.Ss_Delete:
          this.isSsDeleteAllowed = true;
          break;
        case PermissionsEnum.F11_View:
          this.isF11ViewAllowed = true;
          break;
        case PermissionsEnum.F11_CreateEdit:
          this.isF11CreateEditAllowed = true;
          break;
        case PermissionsEnum.F11_Delete:
          this.isF11DeleteAllowed = true;
          break;
        case PermissionsEnum.Area_View:
          this.isAreaViewAllowed = true;
          break;
        case PermissionsEnum.Area_CreateEdit:
          this.isAreaCreateEditAllowed = true;
          break;
        case PermissionsEnum.Area_Delete:
          this.isAreaDeleteAllowed = true;
          break;
        case PermissionsEnum.Region_View:
          this.isRegionViewAllowed = true;
          break;
        case PermissionsEnum.Region_CreateEdit:
          this.isRegionCreateEditAllowed = true;
          break;
        case PermissionsEnum.Region_Delete:
          this.isRegionDeleteAllowed = true;
          break;
        case PermissionsEnum.MeterType_View:
          this.isMeterTypeViewAllowed = true;
          break;
        case PermissionsEnum.MeterType_CreateEdit:
          this.isMeterTypeCreateEditAllowed = true;
          break;
        case PermissionsEnum.MeterType_Delete:
          this.isMeterTypeDeleteAllowed = true;
          break;
        case PermissionsEnum.AssetRating_View:
          this.isAssetRatingViewAllowed = true;
          break;
        case PermissionsEnum.AssetRating_CreateEdit:
          this.isAssetRatingCreateEditAllowed = true;
          break;
        case PermissionsEnum.AssetRating_Delete:
          this.isAssetRatingDeleteAllowed = true;
          break;
        case PermissionsEnum.MeterPrice_View:
          this.isMeterPriceViewAllowed = true;
          break;
        case PermissionsEnum.MeterPrice_CreateEdit:
          this.isMeterPriceCreateEditAllowed = true;
          break;
        case PermissionsEnum.MeterPrice_Delete:
          this.isMeterPriceDeleteAllowed = true;
          break;
        case PermissionsEnum.AssetStatus_View:
          this.isAssetStatusViewAllowed = true;
          break;
        case PermissionsEnum.AssetStatus_CreateEdit:
          this.isAssetStatusCreateEditAllowed = true;
          break;
        case PermissionsEnum.AssetStatus_Delete:
          this.isAssetStatusDeleteAllowed = true;
          break;
        case PermissionsEnum.DtMeterType_View:
          this.isDtMeterTypeViewAllowed = true;
          break;
        case PermissionsEnum.DtMeterType_CreateEdit:
          this.isDtMeterTypeCreateEditAllowed = true;
          break;
        case PermissionsEnum.DtMeterType_Delete:
          this.isDtMeterTypeDeleteAllowed = true;
          break;
        case PermissionsEnum.Tariff_View:
          this.isTariffViewAllowed = true;
          break;
        case PermissionsEnum.Tariff_CreateEdit:
          this.isTariffCreateEditAllowed = true;
          break;
        case PermissionsEnum.Tariff_Delete:
          this.isTariffDeleteAllowed = true;
          break;
        case PermissionsEnum.AuditLog_View:
          this.isAuditLogViewAllowed = true;
          break;
        case PermissionsEnum.AuditLog_Download:
          this.isAuditLogDownloadAllowed = true;
          break;
        case PermissionsEnum.Disconnection:
          this.isDisconnectionAllowed = true;
          break;
        case PermissionsEnum.Outages:
          this.isOutagesAllowed = true;
          break;
        case PermissionsEnum.AuditStatus:
          this.isAuditStatusAllowed = true;
          break;
        case PermissionsEnum.ValidationStatus:
          this.isValidationStatusAllowed = true;
          break;
        case PermissionsEnum.ReviewStatus:
          this.isReviewStatusAllowed = true;
          break;
        case PermissionsEnum.SiteVerification:
          this.isSiteVerificationAllowed = true;
          break;
        case PermissionsEnum.Maintenance:
          this.isWorkOrderMaintenanceAllowed = true;
          break;
        case PermissionsEnum.Slt_View:
          this.isSltViewAllowed = true;
          break;
        case PermissionsEnum.Slt_CreateEdit:
          this.isSltCreateEditAllowed = true;
          break;
        case PermissionsEnum.Slt_Delete:
          this.isSltDeleteAllowed = true;
          break;
        case PermissionsEnum.Customer_Regularization:
          this.isCustomerRegularizationAllowed = true;
          break;
        case PermissionsEnum.Customer_ServiceRequestViewCrud:
          this.isCustomerServiceRequestViewCrudAllowed = true;
          break;
        case PermissionsEnum.Customer_NewEntryViewCrud:
          this.isCustomerNewEntryViewCrudAllowed = true;
          break;
        case PermissionsEnum.Customer_FailedSyncNotification:
          this.isCustomerFailedSyncNotificationAllowed = true;
          break;
        case PermissionsEnum.Customer_FeederBandAlignmentNotification:
          this.isCustomerFeederBandAlignmentNotificationAllowed = true;
          break;
        case PermissionsEnum.Organization_Create:
          this.isCreateOrganizationAllowed = true;
          break;
        case PermissionsEnum.PaymentHistory_View:
          this.isPaymentHistoryViewAllowed = true;
          break;
        case PermissionsEnum.PaymentHistory_Download:
          this.isPaymentHistoryDownloadAllowed = true;
          break;
        case PermissionsEnum.Settlement_View:
          this.isSettlementViewAllowed = true;
          break;
        case PermissionsEnum.Settlement_Download:
          this.isSettlementDownloadAllowed = true;
          break;
        case PermissionsEnum.CustomerMeterStockInventory_View:
          this.isCustomerMeterStockInventoryViewAllowed = true;
          break;
        case PermissionsEnum.CustomerMeterStockInventory_Create:
          this.isCustomerMeterStockInventoryCreateAllowed = true;
          break;
        case PermissionsEnum.CustomerMeterStockInventory_ViewUtilizationStock:
          this.isCustomerMeterStockInventoryViewUtilizationStockAllowed = true;
          break;
        case PermissionsEnum.CustomerDecommissionedMeterStock_View:
          this.isCustomerDecommissionedMeterStockViewAllowed = true;
          break;
        case PermissionsEnum.CustomerDecommissionedMeterStock_Approve:
          this.isCustomerDecommissionedMeterStockApproveAllowed = true;
          break;
        case PermissionsEnum.CustomerDecommissionedMeterStock_Edit:
          this.isCustomerDecommissionedMeterStockEditAllowed = true;
          break;
        case PermissionsEnum.AssetMeterStockInventory_View:
          this.isAssetMeterStockInventoryViewAllowed = true;
          break;
        case PermissionsEnum.AssetMeterStockInventory_Create:
          this.isAssetMeterStockInventoryCreateAllowed = true;
          break;
        case PermissionsEnum.AssetMeterStockInventory_ViewUtilizationStock:
          this.isAssetMeterStockInventoryViewUtilizationStockAllowed = true;
          break;
        case PermissionsEnum.CtvtMeterStockInventory_View:
          this.isCtvtMeterStockInventoryViewAllowed = true;
          break;
        case PermissionsEnum.CtvtMeterStockInventory_Create:
          this.isCtvtMeterStockInventoryCreateAllowed = true;
          break;
        case PermissionsEnum.CtvtMeterStockInventory_ViewUtilizationStock:
          this.isCtvtMeterStockInventoryViewUtilizationStockAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_View:
          this.isDtMeterInstallationViewAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_CreateEdit:
          this.isDtMeterInstallationCreateEditAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_Delete:
          this.isDtMeterInstallationDeleteAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_ApproveReject:
          this.isDtMeterInstallationApproveRejectAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_Recall:
          this.isDtMeterInstallationRecallAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_AcceptDecline:
          this.isDtMeterInstallationAcceptDeclineAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_ApproveMeter:
          this.isDtMeterInstallationApproveMeterAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_ApproveInvoice:
          this.isDtMeterInstallationApproveInvoiceAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_RecallAwaitingApproval:
          this.isDtMeterInstallationRecallAwaitingApprovalAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_AcknowledgeRepayment:
          this.isDtMeterInstallationAcknowledgeRepaymentAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_ViewMeterApproval:
          this.isDtMeterInstallationViewMeterApprovalAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_ViewInvoiceApproval:
          this.isDtMeterInstallationViewInvoiceApprovalAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_ViewActiveRepayment:
          this.isDtMeterInstallationViewActiveRepaymentAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_ViewCompletedPayment:
          this.isDtMeterInstallationViewCompletedPaymentAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_AuthorizeMetering:
          this.isDtMeterInstallationAuthorizeMeteringAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_VendorAssignment:
          this.isDtMeterInstallationVendorAssignmentAllowed = true;
          break;
        case PermissionsEnum.DtMeterInstallation_DeclineReport:
          this.isDtMeterInstallationDeclineReportAllowed = true;
          break;
        case PermissionsEnum.MeterReading:
          this.isMeterReadingAllowed = true;
          break;
        case PermissionsEnum.BillingAccounts_View:
          this.isBillingAccountsViewAllowed = true;
          break;
        case PermissionsEnum.BillingAccounts_CreateEdit:
          this.isBillingAccountsCreateEditAllowed = true;
          break;
        case PermissionsEnum.BillingAccounts_Delete:
          this.isBillingAccountsDeleteAllowed = true;
          break;
        case PermissionsEnum.Pole_Sweep:
          this.isPoleSweepAllowed = true;
          break;
        case PermissionsEnum.Building_Sweep:
          this.isBuildingSweepAllowed = true;
          break;
        case PermissionsEnum.Customer_Sweep:
          this.isCustomerSweepAllowed = true;
          break;
        case PermissionsEnum.Map_View:
          this.isMapViewAllowed = true;
          break;
        case PermissionsEnum.Dashboard_MeterValidation:
          this.isDashboardMeterValidationAllowed = true;
          break;
        case PermissionsEnum.Meter_Validation_View:
          this.isMeterValidationViewAllowed = true;
          break;
        case PermissionsEnum.Meter_Validation_CreateEdit:
          this.isMeterValidationCreateEditAllowed = true;
          break;
        case PermissionsEnum.Meter_Validation_ApproveReject:
          this.isMeterValidationApproveRejectAllowed = true;
          break;
        case PermissionsEnum.AI_UAV_Overview:
          this.isAIUAVOverviewAllowed = true;
          break;
        case PermissionsEnum.AI_UAV_Batch_Image_Import:
          this.isAIUAVBatchImageImportAllowed = true;
          break;
        case PermissionsEnum.AI_UAV_Segmentation_List:
          this.isAIUAVSegmentationListAllowed = true;
          break;
        case PermissionsEnum.AI_UAV_Job_Monitoring:
          this.isAIUAVJobMonitoringAllowed = true;
          break;
        case PermissionsEnum.Readings_View:
          this.isReadingsAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_View:
          this.isNetworkStructureViewAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_CreateEdit:
          this.isNetworkStructureCreateEditAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_Assign:
          this.isNetworkStructureAssignAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_ApproveReject:
          this.isNetworkStructureApproveRejectAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_Review:
          this.isNetworkStructureReviewAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_AuditReview:
          this.isNetworkStructureAuditReviewAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_RecallValidated:
          this.isNetworkStructureRecallValidatedAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_RecallAssigned:
          this.isNetworkStructureRecallAssignedAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_Download:
          this.isNetworkStructureDownloadAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_Delete:
          this.isNetworkStructureDeleteAllowed = true;
          break;
        case PermissionsEnum.NetworkStructure_GisReview:
          this.isNetworkStructureGisReviewAllowed = true;
          break;
        case PermissionsEnum.NetworkEntityClasses_View:
          this.isNetworkEntityClassesViewAllowed = true;
          break;
        case PermissionsEnum.NetworkEntityClasses_CreateEdit:
          this.isNetworkEntityClassesCreateEditAllowed = true;
          break;
        case PermissionsEnum.NetworkEntityClasses_Delete:
          this.isNetworkEntityClassesDeleteAllowed = true;
          break;
        case PermissionsEnum.SchematicDiagram_View:
          this.isSchematicDiagramViewAllowed = true;
          break;
        case PermissionsEnum.SchematicDiagram_CreateEdit:
          this.isSchematicDiagramCreateEditAllowed = true;
          break;
        case PermissionsEnum.DataModelCustomization_View:
          this.isDataModelCustomizationViewAllowed = true;
          break;
        case PermissionsEnum.MeterAssignment_View:
          this.isMeterAssignmentViewAllowed = true;
          break;
        case PermissionsEnum.MeterAssignment_CreateEdit:
          this.isMeterAssignmentCreateEditAllowed = true;
          break;
        case PermissionsEnum.MeterAssignment_Delete:
          this.isMeterAssignmentDeleteAllowed = true;
          break;
        case PermissionsEnum.ServiceRequestTracker_View:
          this.isServiceRequestTrackerViewAllowed = true;
          break;
        case PermissionsEnum.AuditTrail_View:
          this.isAuditTrailViewAllowed = true;
          break;
        case PermissionsEnum.AuditTrail_Download:
          this.isAuditTrailDownloadAllowed = true;
          break;
      }
    }
  }

  initializeDashboardConfigPermissions() {
    let configuration = localStorage.getItem('configuration');
    if (!configuration) {
      return;
    }

    let configurations = configuration ? JSON.parse(configuration) : [];

    for (let index = 0; index < configurations.length; index++) {
      const config: number = configurations[index];

      switch (config) {
        case DashboardConfiguration.MeterValidation:
          this.hasDashboardConfigMeterValidation = true;
          break;
        case DashboardConfiguration.MeterValidationTamper:
          this.meterValidationTamperEnabled = true;
          break;
        case DashboardConfiguration.DtConfirmation:
          this.dtConfirmationEnabled = true;
          break;
        case DashboardConfiguration.NewService:
          this.hasDashboardConfigNewService = true;
          break;
        case DashboardConfiguration.Buildings:
          this.hasDashboardConfigBuildings = true;
          break;
        case DashboardConfiguration.AccountCreation:
          this.accountCreationEnabled = true;
          break;
        case DashboardConfiguration.EnergySource:
          this.hasDashboardConfigEnergySources = true;
          break;
        case DashboardConfiguration.Meters:
          this.hasDashboardConfigMeters = true;
          break;
        case DashboardConfiguration.Poles:
          this.hasDashboardConfigPoles = true;
          break;
        case DashboardConfiguration.MVPoles:
          this.hasDashboardConfigMVPoles = true;
          break;
        case DashboardConfiguration.DTs:
          this.hasDashboardConfigDTS = true;
          break;
        case DashboardConfiguration.Feeders:
          this.hasDashboardConfigFeeders = true;
          break;
        case DashboardConfiguration.Settlement:
          this.hasDashboardConfigSettlement = true;
          break;
        case DashboardConfiguration.Survey:
          this.hasDashboardConfigSurvey = true;
          break;
        case DashboardConfiguration.Installation:
          this.hasDashboardConfigInstallation = true;
          break;
        case DashboardConfiguration.WorkOrder:
          this.hasDashboardConfigWorkOrder = true;
          break;
        case DashboardConfiguration.MeterCustomers:
          this.hasDashboardConfigMeterCustomers = true;
          break;
        case DashboardConfiguration.MeterAssets:
          this.hasDashboardConfigMeterAssets = true;
          break;
        case DashboardConfiguration.MeterCtvt:
          this.hasDashboardConfigMeterCtvt = true;
          break;
        case DashboardConfiguration.DtMeterInstallation:
          this.hasDashboardConfigDtMeterInstallation = true;
          break;
        case DashboardConfiguration.MeterApprovalAndRepayment:
          this.hasDashboardConfigMeterApprovalAndRepayment = true;
          break;
        case DashboardConfiguration.CustomerManagement:
          this.hasDashboardConfigCustomerManagement = true;
          break;
        case DashboardConfiguration.StandaloneBillingIntegration:
          this.hasDashboardConfigBillingIntegration = true;
          break;
        case DashboardConfiguration.Readings:
          this.hasDashboardConfigReadings = true;
          break;
        case DashboardConfiguration.Map:
          this.hasDashboardConfigMap = true;
          break;
        case DashboardConfiguration.Rmus:
          this.hasDashboardConfigRmus = true;
          break;
        case DashboardConfiguration.AIDroneMap:
          this.hasDashboardConfigAIDroneMap = true;
          break;
        case DashboardConfiguration.DataModelCustomization:
          this.hasDashboardConfigDataModelCustomization = true;
          break;
        case DashboardConfiguration.NetworkEntityClassInstantiation:
          this.hasDashboardConfigNetworkEntityClassInstantiation = true;
          break;
        case DashboardConfiguration.NetworkModelStructure:
          this.hasDashboardConfigNetworkModelStructure = true;
          break;
        case DashboardConfiguration.InjectionSubstation:
          this.hasDashboardConfigInjectionSubstation = true;
          break;
        case DashboardConfiguration.FeederBands:
          this.hasDashboardConfigFeederBands = true;
          break;
        case DashboardConfiguration.PaymentHistory:
          this.hasDashboardConfigPaymentHistory = true;
          break;
         case DashboardConfiguration.CIMDataIntegration:
          this.hasDashboardConfigCIMDataIntegration = true;
          break;
        case DashboardConfiguration.AiWidget:
          this.hasDashboardConfigAiWidget = true;
          break;
      }
    }
  }

  public has(permission?: string): boolean {
    if (!permission) return true;
    return !!(this as any)[permission];
  }
}
